<template>
  <div class="container_view">
    <v-card class="content_card" elevation="10" variant="flat">
      <div>
        <header>
          <v-card-title> Gestión de Usuarios </v-card-title>
          <v-divider class="mx-3"></v-divider>
        </header>

        <div class="content_accion">
          <div>
            <v-text-field
              v-model="search"
              label="Búsqueda"
              prepend-inner-icon="mdi-magnify"
              single-line
              hide-details
              variant="outlined"
              class="filter"
            >
            </v-text-field>
          </div>
          <div>
            <v-btn
              icon="mdi-reload"
              size="small"
              variant="outlined"
              color="indigo-darken-3"
              class="mr-2"
              v-on:click="getUserManagement()"
            >
            </v-btn>

            <!-- Boton de carga masiva de usuarios -->
            <v-btn
              v-if="permission.cargaMasiva"
              prepend-icon="mdi-plus"
              color="indigo-darken-3"
              v-on:click="openForm('CM')"
              class="elevation-0 cargaMasiva"
            >
              Carga Masiva
            </v-btn>

            <v-btn
              v-if="permission.addUser"
              prepend-icon="mdi-plus"
              color="indigo-darken-3"
              v-on:click="openForm('R')"
              class="elevation-0"
            >
              Registrar
            </v-btn>
          </div>
        </div>
      </div>
      <div class="container_table" v-if="permission.getUsers">
        <v-data-table
          :headers="dataSource.headers"
          :items="dataSource.data"
          :search="search"
          :loading="isLoading"
          fixed-header
          class="content_table"
          no-data-text="Sin datos para mostrar"
          loading-text="Cargando información... Espere un momento"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <td>
              <!-- 
              <v-tooltip
                text="Editar"
                location="bottom"
                v-if="permission.editUser"
              >
                <template v-slot:activator="{ props }">
                  <v-btn
                    v-bind="props"
                    class="elevation-0 mr-1"
                    density="comfortable"
                    icon="mdi-pencil"
                    color="indigo-darken-3"
                    :disabled="
                      typeUser !== 'Superadministrador' &&
                      item.tipo === 'Superadministrador'
                    "
                    @click="editUser(item)"
                  >
                  </v-btn>
                </template>
              </v-tooltip>

              <v-tooltip
                text="Cambiar Contraseña"
                location="bottom"
                v-if="permission.changePassword"
              >
                <template v-slot:activator="{ props }">
                  <v-btn
                    v-bind="props"
                    class="elevation-0 mr-1"
                    density="comfortable"
                    icon="mdi-key"
                    color="#E39C13"
                    @click="editPassword(item)"
                  >
                  </v-btn>
                </template>
              </v-tooltip>

              <v-tooltip
                text="Desactivar"
                location="bottom"
                v-if="item.status === 'Activo' && permission.blockUser"
              >
                <template v-slot:activator="{ props }">
                  <v-btn
                    v-bind="props"
                    class="elevation-0 mr-1"
                    density="comfortable"
                    icon="mdi-account-cancel"
                    color="error"
                    @click="selectUser(item)"
                  ></v-btn>
                </template>
              </v-tooltip>

              <v-tooltip
                text="Activar"
                location="bottom"
                v-if="item.status === 'Inactivo' && permission.unlockUser"
              >
                <template v-slot:activator="{ props }">
                  <v-btn
                    v-bind="props"
                    class="elevation-0 mr-1"
                    density="comfortable"
                    icon="mdi-account-reactivate"
                    color="teal-darken-4"
                    @click="selectUser(item)"
                  ></v-btn>
                </template>
              </v-tooltip>

              <v-tooltip text="Eliminar usuario" location="bottom">
                <template v-slot:activator="{ props }">
                  <v-btn
                    v-bind="props"
                    class="elevation-0 mr-1"
                    density="comfortable"
                    icon="mdi-delete"
                    color="error"
                    @click="selectDelete(item)"
                  >
                  </v-btn>
                </template>
              </v-tooltip> -->

              <v-menu location="bottom">
                <template v-slot:activator="{ props }">
                  <v-btn
                    color="primary"
                    v-bind="props"
                    icon="mdi-cog"
                  ></v-btn>
                </template>
                <v-list>
                  <v-list-item>
                    <v-list-item-title
                      class="option_select"
                      :disabled="typeUser !== 'Superadministrador' && item.tipo === 'Superadministrador'"
                      @click="editUser(item)"
                    >
                      <div class="txt_option_select">Editar</div>
                    </v-list-item-title>

                    <v-list-item-title
                      class="option_select"
                      v-if="permission.changePassword"
                      @click="editPassword(item)"
                    >
                      <div class="txt_option_select">Cambiar Contraseña</div>
                    </v-list-item-title>

                    <v-list-item-title
                      class="option_select"
                      v-if="permission.changePassword"
                      @click="selectReset2FA(item)"
                    >
                    <div class="txt_option_select">Restablecer 2FA</div>

                    </v-list-item-title>
                    <v-list-item-title
                      class="option_select"
                      v-if="item.status === 'Activo' && permission.blockUser"
                      @click="selectUser(item)"
                    >
                      <div class="txt_option_select">Desactivar</div>
                    </v-list-item-title>

                    <v-list-item-title
                      class="option_select"
                      v-if="item.status === 'Inactivo' && permission.unlockUser"
                      @click="selectUser(item)"
                    >
                      <div class="txt_option_select">Activar</div>
                    </v-list-item-title>
                    
                    <v-list-item-title
                      class="option_select"
                      @click="selectDelete(item)"
                    >
                      <div class="txt_option_select">Eliminar usuario</div>
                    </v-list-item-title>

                  </v-list-item>
                </v-list>
              </v-menu>

            </td>
          </template>
        </v-data-table>
      </div>
    </v-card>
  </div>
  <template>
    <v-dialog
      v-model="dialogEditType"
      activator="parent"
      persistent
      width="500px"
    >
      <v-card>
        <v-form @submit.prevent="updateUser()">
          <v-card-title>
            <span class="text-h5">Modificación de Usuario</span>
          </v-card-title>
          <v-divider class="mx-3"></v-divider>

          <v-card-text class="mt-4 px-6">
            <div class="col-flex-12">
              <v-select
                v-model="formGroupEditType.data.tipo"
                label="Tipo de Usuario"
                :rules="formGroupEditType.rules.tipo"
                variant="outlined"
                class="w-100"
                :items="arrDataTypeUser"
                item-title="value"
                item-value="key"
              >
              </v-select>
            </div>
            <div class="col-flex-12">
              <v-text-field
                label="Nombre(s)"
                v-model="formGroupEditType.data.nombre"
                :rules="formGroupEditType.rules.nombre"
                variant="outlined"
                class="w-100"
              >
              </v-text-field>
            </div>
            <div class="col-flex-12">
              <v-text-field
                label="Apellido(s)"
                v-model="formGroupEditType.data.apellido"
                :rules="formGroupEditType.rules.apellido"
                variant="outlined"
                class="w-100"
              >
              </v-text-field>
            </div>
            <div class="col-flex-12">
              <v-text-field
                label="Usuario SCL"
                v-model="formGroupEditType.data.user_scl"
                :rules="formGroupEditType.rules.user_scl"
                variant="outlined"
                class="w-100 mb-2"
              >
              </v-text-field>
            </div>
          </v-card-text>
          <v-card-actions class="actions_buttons">
            <v-btn
              variant="flat"
              color="red"
              class="text-none"
              @click="dialogEditType = false"
            >
              Cerrar
            </v-btn>
            <v-btn
              variant="flat"
              :loading="isLoadingForm"
              color="indigo-darken-3"
              type="submit"
              class="text-none"
              :disabled="validateFormEdit()"
            >
              Guardar
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </template>
  <template>
    <v-dialog
      v-model="dialogChangePassword"
      activator="parent"
      persistent
      width="500px"
    >
      <v-card>
        <v-form @submit.prevent="updatePassword()">
          <v-card-title>
            <span class="text-h5">Modificación de Contraseña</span>
          </v-card-title>
          <v-divider class="mx-3"></v-divider>

          <v-card-text class="mt-4 px-6">
            <div class="col-flex-12">
              <v-text-field
                label="Contraseña"
                v-model="formGroupChangePassword.data.contrasena"
                :rules="formGroupChangePassword.rules.contrasena"
                variant="outlined"
                class="w-100 mb-2"
                :type="visiblePassword1 ? 'text' : 'password'"
                @click:append-inner="visiblePassword1 = !visiblePassword1"
                :append-inner-icon="
                  visiblePassword1 ? 'mdi-eye-off' : 'mdi-eye'
                "
              >
              </v-text-field>
            </div>
            <div class="col-flex-12">
              <v-text-field
                label="Repetir contraseña"
                v-model="formGroupChangePassword.data.repetirContrasena"
                :rules="formGroupChangePassword.rules.repetirContrasena"
                variant="outlined"
                class="w-100 mb-2"
                :type="visiblePassword2 ? 'text' : 'password'"
                @click:append-inner="visiblePassword2 = !visiblePassword2"
                :append-inner-icon="
                  visiblePassword2 ? 'mdi-eye-off' : 'mdi-eye'
                "
              >
              </v-text-field>
            </div>
          </v-card-text>
          <v-card-actions class="actions_buttons">
            <v-btn
              variant="flat"
              color="red"
              class="text-none"
              @click="
                dialogChangePassword = false;
                formGroupChangePassword.data.contrasena = '';
                formGroupChangePassword.data.repetirContrasena = '';
              "
            >
              Cerrar
            </v-btn>
            <v-btn
              variant="flat"
              color="indigo-darken-3"
              class="text-none"
              :loading="isLoadingForm"
              type="submit"
              text="Guardar"
              :disabled="validatePassword()"
            ></v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </template>
  <template>
    <v-dialog v-model="dialogAlert" width="auto" persistent>
      <v-card>
        <v-card-title>
          <span class="text-h5">Confirmación</span>
        </v-card-title>
        <v-card-text>
          <div class="text-center">
            <img src="@/assets/images/warning.png" />
          </div>
          <div class="description-text">
            <p>¿Está seguro de desactivar el usuario?</p>
          </div>
        </v-card-text>
        <v-card-actions class="actions_buttons">
          <v-btn
            variant="flat"
            color="red"
            class="text-none"
            @click="dialogAlert = false"
          >
            Cerrar
          </v-btn>
          <v-btn
            variant="flat"
            color="indigo-darken-3"
            class="text-none"
            :loading="isLoadingForm"
            @click="deleteUser()"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  <template>
    <v-dialog v-model="dialogDeleteUser" width="auto" persistent>
      <v-card>
        <v-card-title>
          <span class="text-h5">Confirmación</span>
        </v-card-title>
        <v-card-text>
          <div class="text-center">
            <img src="@/assets/images/warning.png" />
          </div>
          <div class="description-text">
            <p>¿Está seguro de eliminar el usuario?</p>
          </div>
        </v-card-text>
        <v-card-actions class="actions_buttons">
          <v-btn
            variant="flat"
            color="red"
            class="text-none"
            @click="dialogDeleteUser = false"
          >
            Cerrar
          </v-btn>
          <v-btn
            variant="flat"
            color="indigo-darken-3"
            class="text-none"
            :loading="isLoadingForm"
            @click="deleteRealUser()"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  <template>
    <v-dialog v-model="dialogActivate" width="auto" persistent>
      <v-card>
        <v-card-title>
          <span class="text-h5">Confirmación</span>
        </v-card-title>
        <v-card-text>
          <div class="text-center">
            <img src="@/assets/images/warning.png" />
          </div>
          <div class="description-text">
            <p>¿Está seguro de activar el usuario?</p>
          </div>
        </v-card-text>
        <v-card-actions class="actions_buttons">
          <v-btn
            variant="flat"
            color="red"
            class="text-none"
            @click="dialogActivate = false"
          >
            Cerrar
          </v-btn>
          <v-btn
            variant="flat"
            color="indigo-darken-3"
            class="text-none"
            :loading="isLoadingForm"
            @click="activateUser()"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>

  <template>
    <v-dialog v-model="dialogCargaMasiva" width="800" persistent>
      <v-card>
        <v-card-title>
          <span class="text-h5">Carga masiva de usuarios</span>
        </v-card-title> 
        <v-card-text>
          <v-form class="override_content_flex" @submit.prevent="saveCargaMasiva()">
            <div class="col-flex-12">
              <v-select
                label="Despachos"
                v-model="formCargaMasiva.data.despachos"
                :rules="formCargaMasiva.rules.despachos"
                variant="outlined"
                :items="arrDispatch"
                item-title="nombre"
                item-value="nombre_bd"                            
                class="w-100">
              </v-select>
            </div>
            <div class="col-flex-12">
              <v-file-input label="File input"
                v-model="formCargaMasiva.data.file"
                :rules="formCargaMasiva.rules.file"
              ></v-file-input>
            </div> 
            <div style="width: 100%; display: flex; flex-direction: row-reverse; padding: 16px 16px;">
              <v-btn 
                v-if="permission.cargaMasiva"
                color="indigo-darken-3"
                prepend-icon="mdi-content-save"
                :loading="isLoadingForm"
                type="submit"
                text="Guardar"
                class="text-none"
                :disabled="!validateFormCargaMasiva()"
              ></v-btn>
              <v-btn
                color="grey-darken-3"
                prepend-icon="mdi-close"
                class="text-none mr-2"
                @click="closeFormCargaMasiva()"
                text="Cerrar"                
              ></v-btn>
            </div>
          </v-form>
        </v-card-text>              
      </v-card>
    </v-dialog>
  </template>

  <template>
    <v-dialog v-model="dialogError" width="600px" persistent>
      <v-card>
        <v-card-title>
          <span class="text-h5">Ocurrió un error</span>
        </v-card-title>
        <div v-if="!isLoadingUpload">
          <div class="text-center">
            <img class="img_alert" src="@/assets/images/warning.png">
          </div>
          <div class="description-text">
            <div class="content_data_errors">
              <div class="content_table">
                <div class="header_columna">Columna</div>
                <div class="header_columna">Fila</div>
                <div class="header_mensaje">Mensaje</div>
              </div>
              <div class="content_table" v-for="(item, index) in arrErrors" :key="index">
                <div class="item_columna">{{ item.columna }}</div>
                <div class="item_columna">{{ item.fila }}</div>
                <div class="item_mensaje">{{ item.mensaje }}</div>
              </div>
            </div>
          </div>
        </div>
        <v-card-actions class="actions_buttons">
          <v-btn 
            variant="flat"
            class="text-none"
            color="red"
            @click="dialogError = false"
            text="Aceptar"
          ></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="reset2FADialog" width="600px" persistent>
      <v-card>
        <v-card-title>
          <span class="text-h5">Restablecer 2FA</span>
        </v-card-title>
        <v-card-text>
          <div class="text-center">
            <img src="@/assets/images/warning.png" />
          </div>
          <div class="description-text">
            <p>¿Está seguro de restablecer la autenticación de dos factores (2FA) para este usuario?</p>
          </div>
        </v-card-text>
        <v-card-actions class="actions_buttons">
          <v-btn
            variant="flat"
            color="red"
            class="text-none"
            @click="reset2FADialog = false"
          >
            Cerrar
          </v-btn>
          <v-btn
            variant="flat"
            color="indigo-darken-3"
            class="text-none"
            :loading="isLoadingForm"
            @click="confirmReset2FA()"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  <SnackbarComponent :value="snackbarData" />
</template>

<script>
import { EncryptService } from "@/services/EncryptService";
import { UserManagementService } from "@/services/UserManagementService";
import { DispatchService } from '@/services/DispatchService';
import SnackbarComponent from "@/components/Snackbar.vue";
export default {
  name: "LoginView",
  props: {
    msg: String,
  },
  components: {
    SnackbarComponent,
  },
  data() {
    return {
      isLoading: false,
      isLoadingForm: false,
      visiblePassword1: false,
      visiblePassword2: false,
      dialogChangePassword: false,
      reset2FADialog: false,
      search: "",
      dataSource: {
        headers: [
          {
            align: "start",
            key: "id",
            title: "No. Cliente",
          },
          {
            key: "name",
            title: "Nombre(s)",
          },
          {
            key: "last_name",
            title: "Apellido(s)",
          },
          {
            key: "tipo",
            title: "Tipo de Usuario",
          },
          {
            key: "user_scl",
            title: "Usuario SCL",
          },
          {
            key: "username",
            title: "Usuario",
          },
          {
            key: "despacho",
            title: "Despacho",
          },
          {
            key: "status",
            title: "Estado",
          },
          {
            key: "actions",
            title: "Acciones",
          },
        ],
        data: [],
        page: 1,
        itemsPerPage: 5,
      },
      snackbarData: {
        openSnackbar: false,
        description: "",
      },
      dialogEditType: false,
      dialogAlert: false,
      dialogActivate: false,
      dialogDeleteUser: false,
      dialogCargaMasiva: false,
      formGroupEditType: {
        data: {
          tipo: null,
          nombre: null,
          apellido: null,
          usuario: null,
          user_scl: null,
        },
        rules: {
          tipo: [
            (value) => {
              if (value) {
                return true;
              }
              return `El campo Tipo de Usuario es obligatorio`;
            },
          ],
          nombre: [
            (value) => {
              if (value) {
                return true;
              }
              return `El campo Nombre(s) es obligatorio`;
            },
          ],
          apellido: [
            (value) => {
              if (value) {
                return true;
              }
              return `El campo Apellido(s) es obligatorio`;
            },
          ],
          usuario: [
            (value) => {
              if (value) {
                return true;
              }
              return `El campo Usuario es obligatorio`;
            },
          ],
          user_scl: [
            (value) => {
              if (value) {
                return true;
              }
              return `El campo Correo Electrónico es obligatorio`;
            },
          ],
        },
      },
      formGroupChangePassword: {
        data: {
          contrasena: "",
          repetirContrasena: "",
        },
        rules: {
          contrasena: [
            (value) => {
              if (value === "") {
                return `El campo contraseña es obligatorio`;
              }

              if (value.length < 8) {
                return `El campo contraseña debe tener al menos 8 caracteres.`;
              }

              if (
                !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&/+-])[A-Za-z\d$@$!%*?&]{8,}$/.test(
                  value
                )
              ) {
                return "La contraseña debe tener mínimo 8 caracteres, con al menos: una mayúscula, una minúscula, un número y un carácter especial ($ @ ! % * ? &). Caduca en 45 días.";
              }

              return true;
            },
          ],
          repetirContrasena: [
            (value) => {
              if (value === "") {
                return `El campo Repetir contraseña es obligatorio`;
              }

              if (value.length < 8) {
                return `El campo Repetir Contraseña debe tener al menos 8 caracteres`;
              }
              
              if (value !== this.formGroupChangePassword.data.contrasena) {
                return "Las contraseñas no coinciden";
              }

              if (
                !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&/+-])[A-Za-z\d$@$!%*?&]{8,}$/.test(
                  value
                )
              ) {
                return "La contraseña debe tener mínimo 8 caracteres, con al menos: una mayúscula, una minúscula, un número y un carácter especial ($ @ ! % * ? &). Caduca en 45 días.";
              }
              return true;
            },
          ],
        },
      },
      arrDataTypeUser: [
        {
          key: "Administrador",
          value: "Administrador",
        },
        {
          key: "Supervisor",
          value: "Supervisor",
        },
        {
          key: "Gestor",
          value: "Gestor",
        },
        {
          key: "Colaborador",
          value: "Gestor de Campo",
        },
      ],
      formCargaMasiva:{
        data: {                    
          despachos: null,
          file:null,                    
        },
        rules: {                    
          despachos: [
            value => {
              if (value) {
                return true
              }
              return `El campo Despachos es obligatorio`
            }
          ],
          file: [
            value => {
              if (value) {
                return true
              }
              return `El campo Archivo es obligatorio`
            }
          ],                    
        }
      },
      idUserEdit: 0,
      typeUser: "",
      permission: {
        addUser: false,
        blockUser: false,
        unlockUser: false,
        getUsers: false,
        editUser: false,
        changePassword: false,
        cargaMasiva:false,
      },
      arrErrors: [],      
      dialogError: false,
    };
  },
  async created() {
    const ENC_TYPEUSER = localStorage.getItem("TIPO");
    this.typeUser = await EncryptService.decrypt(ENC_TYPEUSER);
    if (this.typeUser === "Superadministrador") {
      this.arrDataTypeUser.push({
        key: "Superadministrador",
        value: "Super Administrador",
      });
    }

    const ENC_PERMISOS = localStorage.getItem("PERMISOS");
    const STR_PERMISOS = atob(ENC_PERMISOS);
    const ARR_PERMISOS = JSON.parse(STR_PERMISOS);
    const PERMISSION = ARR_PERMISOS.find(
      (permission) => permission.modulo === "M05GEUS"
    );
    for (const element of PERMISSION.endpoints) {
      if (element.nombre === "M05F01AGUS" && element.permiso === true) {
        this.permission.addUser = true;
      }
      if (element.nombre === "M05F03BLUS" && element.permiso === true) {
        this.permission.blockUser = true;
      }
      if (element.nombre === "M05F03DEUS" && element.permiso === true) {
        this.permission.unlockUser = true;
      }
      if (element.nombre === "M05F03COUS" && element.permiso === true) {
        this.permission.getUsers = true;
      }
      if (element.nombre === "M05F02EDUS" && element.permiso === true) {
        this.permission.editUser = true;
      }
      if (element.nombre === "M05F03CACO" && element.permiso === true) {
        this.permission.changePassword = true;
      }
      if (element.nombre === "M05F04AGMS" && element.permiso === true) {
        this.permission.cargaMasiva = true;
      }
    }
  },
  async mounted() {
    await this.getUserManagement();
    await this.checkPermissions();
    await this.getDispatch();
  },
  methods: {
    getUserManagement: async function () {
      this.isLoading = true;
      const TYPE = localStorage.getItem("TIPO");
      await UserManagementService.getUserManagement(TYPE).then(
        (responseData) => {
          if (!responseData.error) {
            responseData.response.forEach((element) => {
              element.user_scl =
                element.user_scl === null ||
                element.user_scl === "" ||
                element.user_scl === undefined
                  ? "N/A"
                  : element.user_scl;
              element.actions = "acciones";
            });
            this.dataSource.data = responseData.response;
          } else {
            this.snackbarData.description = responseData.msg;
            this.snackbarData.openSnackbar = true;
          }
        }
      );
      this.isLoading = false;
    },
    getDispatch: async function () {
      await DispatchService.getDispatch().then(
        (responseData) => {
          if (!responseData.error) {
            this.arrDispatch = responseData.response
          } else {
            this.snackbarData.description = responseData.msg
            this.snackbarData.openSnackbar = true
          }
        }
      )
    },
    openForm: async function (typeForm, userManagement) {
      if (typeForm === "R") {
        let form = {
          type: typeForm,
        };
        let strForm = JSON.stringify(form);
        let encForm = await EncryptService.encrypt(strForm);
        this.$router.push(`/SGCCV/user-management/form/${encForm}`);
      } else if (typeForm === "M" && userManagement !== undefined) {
        let form = {
          type: typeForm,
          idUser: userManagement.id,
        };
        let strForm = JSON.stringify(form);
        let encForm = await EncryptService.encrypt(strForm);
        this.$router.push(`/SGCCV/user-management/form/${encForm}`);
      } else if(typeForm == 'CM'){ 

        this.dialogCargaMasiva = true;

      }else {
        this.snackbarData.description = "Opción no disponible";
        this.snackbarData.openSnackbar = true;
      }
    },
    editUser: function (user) {
      this.idUserEdit = user.id;
      this.formGroupEditType.data.tipo = user.tipo;
      this.dialogEditType = true;

      this.formGroupEditType.data.nombre = user.name;
      this.formGroupEditType.data.apellido = user.last_name;
      this.formGroupEditType.data.user_scl = user.user_scl;
    },
    updateUser: async function () {
      this.isLoadingForm = true;
      const ENC_USER = await EncryptService.encrypt(this.idUserEdit.toString());

      const TIPO = this.formGroupEditType.data.tipo;
      const ENC_TIPO = await EncryptService.encrypt(TIPO);

      const NOMBRE = this.formGroupEditType.data.nombre;
      const ENC_NOMBRE = await EncryptService.encrypt(NOMBRE);

      const APELLIDO = this.formGroupEditType.data.apellido;
      const ENC_APELLIDO = await EncryptService.encrypt(APELLIDO);

      const USER_SCL = this.formGroupEditType.data.user_scl;
      const ENC_USER_SCL = await EncryptService.encrypt(USER_SCL);

      const formData = new FormData();
      formData.append("tipo", ENC_TIPO);
      formData.append("nombre", ENC_NOMBRE);
      formData.append("apellido", ENC_APELLIDO);
      formData.append("user_scl", ENC_USER_SCL);

      await UserManagementService.updateUserType(formData, ENC_USER).then(
        async (responseData) => {
          if (!responseData.error) {
            this.snackbarData.description = `¡Modificación exitosa!`;
            this.snackbarData.openSnackbar = true;
            this.dialogEditType = false;
            await this.getUserManagement();
          } else {
            this.snackbarData.description = responseData.msg;
            this.snackbarData.openSnackbar = true;
          }
        }
      );
      this.isLoadingForm = false;
    },
    editPassword: function (user) {
      this.idUserEdit = user.id;
      this.dialogChangePassword = true;
    },
    confirmReset2FA: async function(){
      this.isLoadingForm = true;
      const ENC_USER = await EncryptService.encrypt(this.idUserEdit.toString());
      await UserManagementService.reset2FA(ENC_USER).then(
        async (responseData) => {
          if (!responseData.error) {
            this.snackbarData.description = `¡Restablecimiento exitoso!`;
            this.snackbarData.openSnackbar = true;            
            await this.getUserManagement();
          } else {
            this.snackbarData.description = responseData.msg;
            this.snackbarData.openSnackbar = true;
          }
        }
      );
      this.isLoadingForm = false;
      this.reset2FADialog = false;
    },
    updatePassword: async function () {
      this.isLoadingForm = true;

      const PASSWORD1 = this.formGroupChangePassword.data.contrasena;
      const PASSWORD2 = this.formGroupChangePassword.data.repetirContrasena;

      const ENC_PASSWORD1 = await EncryptService.encrypt(PASSWORD1);
      const ENC_PASSWORD2 = await EncryptService.encrypt(PASSWORD2);

      const formData = new FormData();
      formData.append("nueva_contrasena", ENC_PASSWORD1);
      formData.append("confirmar_contrasena", ENC_PASSWORD2);

      const ENC_USER = await EncryptService.encrypt(this.idUserEdit.toString());

      await UserManagementService.updatePassword(formData, ENC_USER).then(
        async (responseData) => {
          if (!responseData.error) {
            this.snackbarData.description = `¡Modificación exitosa!`;
            this.snackbarData.openSnackbar = true;
            this.dialogChangePassword = false;
            await this.getUserManagement();
          } else {
            this.snackbarData.description = responseData.msg;
            this.snackbarData.openSnackbar = true;
          }
        }
      );

      this.isLoadingForm = false;
    },
    selectReset2FA: function(user){
      this.idUserEdit = user.id;      
      this.reset2FADialog = true;
    },
    selectUser: function (user) {
      if (user.status === "Activo") {
        this.dialogAlert = true;
      } else {
        this.dialogActivate = true;
      }
      this.idUserEdit = user.id;
    },
    selectDelete: function (user) {
      this.dialogDeleteUser = true;
      this.idUserEdit = user.id;
    },
    deleteRealUser: async function () {
      this.isLoadingForm = true;

      const ENC_USER = await EncryptService.encrypt(this.idUserEdit.toString());
      await UserManagementService.deleteUserReal(ENC_USER).then(
        async (responseData) => {
          if (!responseData.error) {
            this.snackbarData.description = `¡Eliminación Exitosa!`;
            this.snackbarData.openSnackbar = true;
            this.dialogDeleteUser = false;
            await this.getUserManagement();
          } else {
            this.snackbarData.description = responseData.msg;
            this.snackbarData.openSnackbar = true;
          }
        }
      );

      this.isLoadingForm = false;
    },
    deleteUser: async function () {
      this.isLoadingForm = true;

      const ENC_USER = await EncryptService.encrypt(this.idUserEdit.toString());
      await UserManagementService.deleteUser(ENC_USER).then(
        async (responseData) => {
          if (!responseData.error) {
            this.snackbarData.description = `¡Desactivación Exitosa!`;
            this.snackbarData.openSnackbar = true;
            this.dialogAlert = false;
            await this.getUserManagement();
          } else {
            this.snackbarData.description = responseData.msg;
            this.snackbarData.openSnackbar = true;
          }
        }
      );

      this.isLoadingForm = false;
    },
    activateUser: async function () {
      this.isLoadingForm = true;

      const ENC_USER = await EncryptService.encrypt(this.idUserEdit.toString());
      await UserManagementService.deleteUser(ENC_USER).then(
        async (responseData) => {
          if (!responseData.error) {
            this.snackbarData.description = `¡Activación Exitosa!`;
            this.snackbarData.openSnackbar = true;
            this.dialogActivate = false;
            await this.getUserManagement();
          } else {
            this.snackbarData.description = responseData.msg;
            this.snackbarData.openSnackbar = true;
          }
        }
      );
      this.isLoadingForm = false;
    },
    deleteUser2: async function () {},
    checkPermissions: async function () {
      const ENC_TYPE = localStorage.getItem("TIPO");
      const DEC_TYPE = await EncryptService.decrypt(ENC_TYPE);
      const TYPE = DEC_TYPE;
      switch (TYPE) {
        case "Superadministrador":
          this.permissionRegister = true;
          this.permissionBlock = true;
          break;
        case "Administrador":
          this.permissionRegister = false;
          this.permissionBlock = false;
          break;
        case "Supervisor":
          this.permissionRegister = false;
          this.permissionBlock = false;
          break;
        case "Gestor":
          this.permissionRegister = false;
          this.permissionBlock = false;
          break;
        case "Colaborador":
          this.permissionRegister = false;
          this.permissionBlock = false;
          break;
      }
    },
    validatePassword: function () {
      const PASSWORD = this.formGroupChangePassword.data.contrasena;
      if (PASSWORD === null || PASSWORD === undefined || PASSWORD === "") {
        return true;
      }

      const REPIT_PASSWORD =
        this.formGroupChangePassword.data.repetirContrasena;
      if (
        REPIT_PASSWORD === null ||
        REPIT_PASSWORD === undefined ||
        REPIT_PASSWORD === ""
      ) {
        return true;
      }

      if (
        !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&/+-])[A-Za-z\d$@$!%*?&]{8,}$/.test(
          PASSWORD
        )
      ) {
        return true;
      }
      if (
        !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&/+-])[A-Za-z\d$@$!%*?&]{8,}$/.test(
          REPIT_PASSWORD
        )
      ) {
        return true;
      }

      if (PASSWORD !== REPIT_PASSWORD) {
        return true;
      }

      return false;
    },
    validateFormEdit: function () {
      if (
        this.formGroupEditType.data.tipo === null ||
        this.formGroupEditType.data.tipo === ""
      ) {
        return true;
      }
      if (
        this.formGroupEditType.data.nombre === null ||
        this.formGroupEditType.data.nombre === ""
      ) {
        return true;
      }
      if (
        this.formGroupEditType.data.apellido === null ||
        this.formGroupEditType.data.apellido === ""
      ) {
        return true;
      }
      if (
        this.formGroupEditType.data.user_scl === null ||
        this.formGroupEditType.data.user_scl === ""
      ) {
        return true;
      }
      return false;
    },
    validateFormCargaMasiva: function () {
      const DESPACHOS = this.formCargaMasiva.data.despachos
      if (DESPACHOS === null || DESPACHOS === undefined || DESPACHOS === '') {
        return false
      }
      const FILEINPUT = this.formCargaMasiva.data.file
      if (FILEINPUT === null || FILEINPUT === undefined || FILEINPUT === '') {
        return false
      }            
      return true
    },
    saveCargaMasiva: async function(){
      if (!this.permission.cargaMasiva) {
        this.snackbarData.description = `No tienes permisos para realizar el proceso de carga masiva`
        this.snackbarData.openSnackbar = true
        return;
      }

      this.isLoadingForm = true            

      let despachos = this.formCargaMasiva.data.despachos
      despachos = despachos.toString().trim()
      despachos = await EncryptService.encrypt(despachos)                        

      let file = this.formCargaMasiva.data.file
            
      const formData = new FormData();
      formData.append("archivo", file[0]);
      formData.append("despacho", despachos);
            
      await UserManagementService.cargaMasiva(formData).then(
        (responseData) => {          
          this.isLoadingForm = false;
          if (!responseData.error) {
            this.snackbarData.description = `¡Registro Exitoso!`
            this.snackbarData.openSnackbar = true            
            this.dialogCargaMasiva = false;
            this.formCargaMasiva.data.despachos = null;
            this.formCargaMasiva.data.file = null;
          } else {
            this.snackbarData.description = `${ responseData.msg }`
            this.snackbarData.openSnackbar = true
            this.arrErrors = responseData.response
            this.dialogError = true
          }
        }
      )
    },
    closeFormCargaMasiva: function(){
      this.dialogCargaMasiva = false;
      this.formCargaMasiva.data.despachos = null;
      this.formCargaMasiva.data.file = null;
    }
  },
  computed: {
    pageCount() {
      return Math.ceil(this.desserts.length / this.itemsPerPage);
    },
  },
};
</script>

<style scoped>
img {
  height: 230px;
  width: auto;
  padding: 40px;
}

.description-text {
  display: flex;
  justify-content: center;
}

.description-text p {
  width: 90%;
  text-align: center;
}

.actions_buttons {
  display: flex;
  justify-content: flex-end;
}

.option_select {
  cursor: pointer;
  padding: 8px 0 8px 10px;
}

.option_select:hover {
  background-color: #E5E5E5;
}


.v-list-item  {
  padding: 4px 0 !important;
}

.txt_option_select {
  margin-right: 10px;
}

.cargaMasiva{
  margin-right: 4px;
}

.container_data {
  width: 100%;
  margin-top: 16px;
  overflow: auto;
  margin-bottom: 30px;
}
.container_form {
  max-width: 60%;
  min-width: 600px;
  margin: 0 auto;
}
.content_main_report {
  width: 100%; 
  height: calc(100% - 49px); 
  overflow: auto;
}
.container_img {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
}
.container_img img {
  max-height: 200px;
}

.img_alert {
  height: 230px;
  width: auto;
  padding: 40px;
}

.description-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-height: 250px;
  overflow: auto;
}

.description-text p {
  width: 90%;
  text-align: center;
  margin-bottom: 16px;
}

.content_table {
  display: flex;
  overflow: hidden;
}

.header_columna {
  width: 70px;
  display: flex;
  font-weight: 600;
  justify-content: center;
  align-items: center;
}
.header_mensaje {
  width: 350px;
  display: flex;
  font-weight: 600;
  align-items: center;
}

.item_columna {
  width: 70px;
  display: flex;
  justify-content: center;
}

.item_mensaje {
  width: 350px;
  display: flex;
  align-items: center;
}

.content_data_errors {
  max-height: 200px;
  overflow: auto;
}

</style>
